import { useTheme } from "src/hooks";
import { type ICol } from "src/interfaces";
import { useShowContent } from "src/generator/hooks/useShowContent";
import { Text } from "@mantine/core";
import { v4 as uuidv4 } from "uuid";

import RowCell from "../RowCell";
import Header from "../../Header";
import { StyledTable, StyledTh, StyledSplitTh } from "../../../../../styled";
import { Fragment } from "react";
import { getCellWidth } from "../../../../../generator/utils/getCellWidth";

interface Props {
  row: { cols: ICol[]; isDraftEntry?: boolean } | ICol[];
  history?: boolean;
  isOverlay?: boolean;
  rowIndex?: number;
  lbeid?: string;
  showSubRowHeaders?: boolean;
  headers?: ICol[];
  subRowIndex?: number;
  entryIndex?: number;
  divider?: boolean;
  pdfEntry?: boolean;
  layout?: number[];
}

const Row = ({
  row,
  history,
  isOverlay,
  rowIndex,
  lbeid,
  showSubRowHeaders,
  headers,
  subRowIndex,
  entryIndex,
  divider,
  pdfEntry,
  layout,
}: Props) => {
  const theme = useTheme() as any;
  const { shouldHideElement } = useShowContent();

  const data = row ? ("cols" in row ? row.cols : row) : undefined;
  const shouldGenerateSubRowHeaders =
    subRowIndex !== undefined &&
    ((rowIndex === 0 && subRowIndex > 0) || rowIndex !== 0) &&
    showSubRowHeaders &&
    headers &&
    Array.isArray(headers[subRowIndex]);

  const content = (
    <Fragment>
      {shouldGenerateSubRowHeaders &&
        !shouldHideElement(headers[subRowIndex], entryIndex) && (
          <Header
            headers={headers[subRowIndex] as any}
            sIndex={-1}
            headerSize=""
          />
        )}
      {data?.map?.((col: ICol, index: number) => {
        const colAny = col as any;
        if (
          colAny?.feature &&
          colAny?.feature === "hidden" &&
          colAny?.onClass
        ) {
          if (shouldHideElement(colAny, entryIndex)) return null;
        }

        const colSpan = colAny.colspan
          ? colAny.colspan
          : colAny.span
            ? 1 + colAny.span
            : !colAny.full
              ? 1
              : 999;

        // Header styled cells
        if (colAny.headerStyle) {
          const title = [];
          if (colAny.name && colAny.name.indexOf("<br>") > -1) {
            const arr = colAny.name.split("<br>");
            arr.forEach((v: string) =>
              title.push(<StyledSplitTh key={uuidv4()}>{v}</StyledSplitTh>),
            );
          } else {
            title.push(colAny.name);
          }

          return (
            <StyledTh
              key={`header-cell-${index * Math.random()}`}
              colSpan={colSpan}
              style={{ minWidth: getCellWidth(colAny.width) }}>
              <Text inherit c="inherit" span style={{ position: "relative" }}>
                {title}
              </Text>
            </StyledTh>
          );
        }

        return (
          <RowCell
            key={`row-cell-${index * Math.random()}`}
            col={col}
            span={colSpan}
            index={index}
            isOverlay={isOverlay}
            isDraftEntry={(row as any).isDraftEntry}
            history={history}
            rowIndex={rowIndex}
            lbeid={lbeid}
            entryIndex={entryIndex}
            pdfEntry={pdfEntry}
            layout={layout}
          />
        );
      })}
    </Fragment>
  );
  if (shouldGenerateSubRowHeaders)
    return (
      <tr style={{ border: "none" }}>
        <td style={{ padding: 0, border: "none" }} colSpan={999}>
          <table
            style={{
              width: "100%",
              borderSpacing: 0,
              borderCollapse: "collapse",
            }}>
            {content}
          </table>
        </td>
      </tr>
    );

  return (
    <tr
      style={{
        backgroundColor: theme?.colors.tdBackgroundColor[0],
        ...(divider
          ? { borderTop: `2px solid ${theme?.colors.grayscaleBorder[0]}` }
          : {}),
      }}>
      {content}
    </tr>
  );
};

export default Row;
